/**
 * Create a debounced version of a function
 *
 * @param func
 * @param waitMilliseconds How long to wait until firing.
 * @param isImmediate Should the function be fired immediately on first call?
 */
export function debounce(func, waitMilliseconds = 50, isImmediate = false) {
    let timeoutId;
    return function (...args) {
        const context = this;
        const doLater = () => {
            timeoutId = undefined;
            if (!isImmediate) {
                func.apply(context, args);
            }
        };
        const shouldCallNow = isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
}
